import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
    return (
        <div class="navbar lg:hidden shadow-xl h-4 fixed top-0 z-50 bg-gray-800">
            <div class="navbar-start">
                <Link to='/' class="btn btn-ghost text-2xl text-white font-bold uppercase">Jahid's Protfolio</Link>
            </div>
            <div class="navbar-center hidden lg:flex">
                <ul class="menu menu-horizontal p-0">

                </ul>
            </div>
            <div className='navbar-end text-white'>
                <label for="my-drawer-2" tabindex="0" class="btn btn-ghost lg:hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                </label>
            </div>
        </div>
    );
};

export default Navbar;